import { render, staticRenderFns } from "./HeadLineImage.vue?vue&type=template&id=28e6600b&scoped=true&"
import script from "./HeadLineImage.vue?vue&type=script&lang=js&"
export * from "./HeadLineImage.vue?vue&type=script&lang=js&"
import style0 from "./HeadLineImage.vue?vue&type=style&index=0&id=28e6600b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e6600b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e6600b')) {
      api.createRecord('28e6600b', component.options)
    } else {
      api.reload('28e6600b', component.options)
    }
    module.hot.accept("./HeadLineImage.vue?vue&type=template&id=28e6600b&scoped=true&", function () {
      api.rerender('28e6600b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/luckydraw/components/HeadLineImage.vue"
export default component.exports